import { Injectable } from '@angular/core';
import { AuthService} from './auth.service';

declare var gtag: any;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  user: any;

  constructor(private authService: AuthService) { 
    this.user = this.authService.getUser();
  }

  public loginEvent(status: boolean | string): any {
    gtag('event', 'user_login', {
      'userid' : `${this.user.id}` || 'not yet available',
      'status': status ? "success" : "failure"
    });
  }

  public manualAudienceUploadEvent(status: boolean | string): any {
    gtag('event', 'create_manual_audience_upload', {
      'userid' : `${this.user.id}`,
      'status': status ? "success" : "failure"
    });
  }

  public createAudienceStartEvent(): any {
    gtag('event', 'start_audience_build', {
      'userid' : `${this.user.id}`,
    });
  }

  public createAudienceEvent(status: boolean | string): any {
    gtag('event', 'finish_audience_build', {
      'userid' : `${this.user.id}`,
      'status': status ? "success" : "failure"
    });
  }

  public audienceSegmentCreationEvent(status: boolean | string): any {
    gtag('event', 'audience_segment_creation', {
      'userid' : `${this.user.id}`,
      'status': status ? "success" : "failure"
    });
  }

  public senderIdCreationEvent(status: boolean | string): any {
    gtag('event', 'sender_id_creation', {
      'userid' : `${this.user.id}`,
      'status': status ? "success" : "failure"
    });
  }

  public campaignCreationStartEvent(): any {
    gtag('event', 'start_create_campaign', {
      'userid' : `${this.user.id}`
    });
  }

  public campaignCreationFinishEvent(status: boolean | string): any {
    gtag('event', 'finish_create_campaign', {
      'userid' : `${this.user.id}`,
      'status': status ? "success" : "failure"
    });
  }

  public campaignlaunchEvent(status: boolean | string): any {
    gtag('event', 'campaign_launch', {
      'userid' : `${this.user.id}`,
      'status': status ? "success" : "failure"
    });
  }

  public createWalletEvent(status: boolean | string): any {
    gtag('event', 'create_wallet', {
      'userid' : `${this.user.id}`,
      'status': status ? "success" : "failure"
    });
  }

  public accountFundedEvent(status: boolean | string): any {
    gtag('event', 'succesful_account_funding_action', {
      'userid' : `${this.user.id}`,
      'status': status ? "success" : "failure"
    });
  }

  public createTtaEvent(status: boolean | string): any {
    gtag('event', 'create_tta_action', {
      'userid' : `${this.user.id}`,
      'status': status ? "success" : "failure"
    });
  }

  public updateTtaEvent(status: boolean | string): any {
    gtag('event', 'update_tta_action', {
      'userid' : `${this.user.id}`,
      'status': status ? "success" : "failure"
    });
  }

  public createCtaEvent(status: boolean | string): any {
    gtag('event', 'create_cta_action', {
      'userid' : `${this.user.id}`,
      'status': status ? "success" : "failure"
    });
  }

  public updateCtaEvent(status: boolean | string): any {
    gtag('event', 'update_cta_action', {
      'userid' : `${this.user.id}`,
      'status': status ? "success" : "failure"
    });
  }

  public whatsappSetupStartEvent(): any {
    gtag('event', 'whatsapp_start_action', {
      'userid' : `${this.user.id}`,
    });
  }

  public whatsappSetupFinishEvent(status: boolean | string): any {
    gtag('event', 'whatsapp_end_action', {
      'userid' : `${this.user.id}`,
      'status': status ? "success" : "failure"
    });
  }

  public selfsignupEvent(status: boolean | string): any {
    gtag('event', 'user_signup', {
      'userid' : `${this.user.id}` || 'not yet available',
      'status': status ? "success" : "failure"
    });
  }

  public businessCreationEvent(status: boolean | string): any {
    gtag('event', 'user_business_cration', {
      'userid' : `${this.user.id}` || 'not yet available',
      'status': status ? "success" : "failure"
    });
  }

}
